import { FlowEntry, FlowRoute } from '../../types'

/* istanbul ignore file */

const mightyOakCardOnboarding: FlowEntry[] = [
  {
    page: FlowRoute.MOCInterstitial,
    actions: [
      {
        name: 'continue',
        stepEvent: 'moc_progress_step_one',
        goTo: () => FlowRoute.MOCProgressStepOne,
      },
    ],
  },
  {
    page: FlowRoute.MOCProgressStepOne,
    actions: [
      {
        name: 'continue',
        stepEvent: 'personal_info',
        goTo: () => FlowRoute.PersonalInfo,
      },
    ],
  },
  {
    page: FlowRoute.PersonalInfo,
    actions: [
      { name: 'continue', stepEvent: 'information_personal', goTo: () => FlowRoute.ContactInfo },
    ],
  },
  {
    page: FlowRoute.ContactInfo,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_contact',
        goTo: () => FlowRoute.MFASetup,
      },
    ],
  },
  {
    page: FlowRoute.MFASetup,
    actions: [
      {
        name: 'continue',
        stepEvent: 'setup_mfa',
        goTo: () => FlowRoute.SSN,
      },
    ],
  },
  {
    page: FlowRoute.SSN,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_ssn',
        goTo: () => FlowRoute.InvestorQuestions,
      },
    ],
  },
  {
    page: FlowRoute.InvestorQuestions,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_investor_questions',
        goTo: () => FlowRoute.MOCProgressStepTwo,
      },
    ],
  },
  {
    page: FlowRoute.MOCProgressStepTwo,
    actions: [
      {
        name: 'continue',
        stepEvent: 'moc_progress_step_2',
        goTo: () => FlowRoute.PricingInterstitial,
      },
    ],
  },
  {
    page: FlowRoute.PricingInterstitial,
    actions: [
      {
        name: 'continue',
        stepEvent: 'pricing_interstitial',
        goTo: () => FlowRoute.ShippingAddress,
      },
      {
        name: 'skip',
        stepEvent: 'pricing_interstitial',
        goTo: () => FlowRoute.CardOrderReview,
      },
    ],
  },
  {
    page: FlowRoute.ShippingAddress,
    actions: [
      {
        name: 'continue',
        stepEvent: 'shipping_address',
        goTo: () => FlowRoute.Occupation,
      },
      {
        name: 'skip',
        goTo: () => FlowRoute.CardOrderReview,
      },
    ],
  },
  {
    page: FlowRoute.Occupation,
    actions: [
      {
        name: 'continue',
        stepEvent: 'occupation',
        goTo: () => FlowRoute.SignYourCard,
      },
      {
        name: 'skip',
        goTo: () => FlowRoute.CardOrderReview,
      },
    ],
  },
  {
    page: FlowRoute.SignYourCard,
    actions: [
      {
        name: 'continue',
        stepEvent: 'card_signature',
        goTo: () => FlowRoute.CardOrderReview,
      },
    ],
  },
  {
    page: FlowRoute.CardOrderReview,
    actions: [
      {
        name: 'continue',
        stepEvent: 'card_order_review',
        goTo: () => FlowRoute.MOCProgressStepThree,
      },
    ],
  },
  {
    page: FlowRoute.MOCProgressStepThree,
    actions: [
      {
        name: 'continue',
        stepEvent: 'suitability_questions',
        goTo: () => FlowRoute.SuitabilityQuestions,
      },
    ],
  },
  {
    page: FlowRoute.SuitabilityQuestions,
    actions: [
      {
        name: 'continue',
        stepEvent: 'portfolio_questions',
        goTo: () => FlowRoute.Analyzing,
      },
    ],
  },
  {
    page: FlowRoute.Analyzing,
    actions: [
      {
        name: 'continue',
        stepEvent: 'analyzing_portfolio',
        goTo: () => FlowRoute.PreviewPortfolio,
      },
    ],
  },

  {
    page: FlowRoute.CryptoLander,
    actions: [
      {
        name: 'update_crypto_portfolio',
        stepEvent: 'portfolio_breakdown',
        goTo: () => FlowRoute.PreviewPortfolio,
      },
    ],
  },
  {
    page: FlowRoute.AboutPortfolio,
    actions: [{ name: 'goBack', stepEvent: 'goBack', goTo: () => FlowRoute.PreviewPortfolio }],
  },

  {
    page: FlowRoute.PreviewPortfolio,
    actions: [
      {
        name: 'continue',
        stepEvent: 'portfolio_breakdown',
        goTo: () => FlowRoute.Funding,
      },
      {
        name: 'switch',
        stepEvent: 'portfolio_breakdown',
        goTo: () => FlowRoute.MOCReferralReminder,
      },
      {
        name: 'about_portfolio',
        stepEvent: 'about_portfolio',
        goTo: () => FlowRoute.AboutPortfolio,
      },
      {
        name: 'add_bitcoin_etf',
        stepEvent: 'portfolio_breakdown',
        goTo: () => FlowRoute.CryptoLander,
      },
    ],
  },
  {
    page: FlowRoute.MOCReferralReminder,
    actions: [
      { name: 'continue', stepEvent: 'moc_referral_reminder', goTo: () => FlowRoute.Funding },
    ],
  },
  {
    page: FlowRoute.Funding,
    actions: [
      { name: 'continue', stepEvent: 'funding', goTo: () => FlowRoute.MOCSuccess },
      { name: 'more_info', stepEvent: 'referrals_reward', goTo: () => FlowRoute.ReferralReward },
      { name: 'link', stepEvent: 'bank_linking', goTo: () => FlowRoute.Institutions },
    ],
  },
  {
    page: FlowRoute.Institutions,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'direct', goTo: () => FlowRoute.DirectBankIntegration },
      { name: 'skip', goTo: () => FlowRoute.BankLinkSuccess },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
  },
  {
    page: FlowRoute.PlaidLinkRedirect,
    actions: [
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
  },
  {
    page: FlowRoute.DirectBankIntegration,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'skip', goTo: () => FlowRoute.BankLinkSuccess },
      { name: 'partner_skip', goTo: () => FlowRoute.BankLinkSuccess },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
  },
  {
    page: FlowRoute.ManualFundingSource,
    actions: [{ name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess }],
  },
  {
    page: FlowRoute.ChooseFundingSource,
    actions: [
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
    ],
  },
  {
    page: FlowRoute.BankLinkSuccess,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.RecurringDeposit },
      { name: 'skip', goTo: () => FlowRoute.MOCSuccess },
    ],
  },
  {
    page: FlowRoute.RecurringDeposit,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.MOCSuccess },
      { name: 'switch', goTo: () => FlowRoute.OneTimeDeposit },
    ],
  },
  {
    page: FlowRoute.OneTimeDeposit,
    actions: [{ name: 'continue', goTo: () => FlowRoute.MOCSuccess }],
  },
  {
    page: FlowRoute.ReferralReward,
    actions: [{ name: 'continue', goTo: () => FlowRoute.ReferralDisclosure }],
  },
  {
    page: FlowRoute.ReferralDisclosure,
    actions: [{ name: 'continue', goTo: () => FlowRoute.MOCSuccess }],
  },
  {
    page: FlowRoute.MOCSuccess,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.Success },
      { name: 'more-info', goTo: () => FlowRoute.ReferralReward },
    ],
  },
  {
    page: FlowRoute.Success,
    actions: [],
  },
]

export default mightyOakCardOnboarding
